var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src727013012/src/~/core-js/library/modules/_html.js
// module id = FUUR
// module chunks = 6